document.addEventListener( 'DOMContentLoaded', function() {
	const dropdowns = document.querySelectorAll( '.colibri-blocks--menu-based-dropdowns' );
	const DO_NOT_PRESELECT = '-do-not-preselect-';

	if ( !dropdowns.length ) {
		return;
	}

	dropdowns.forEach( function( ctrl ) {
		const hash = ctrl.dataset.hash;
		const button = ctrl.querySelector( 'button[type=submit]' );
		const sel1 = ctrl.querySelector( '.first-level select' );
		const sel2 = ctrl.querySelector( '.second-level select' );
		const sel3 = ctrl.querySelector( '.third-level select' );

		let sel2Source = sel2
						 ? Array.from( sel2.querySelectorAll( 'option:not(:first-child)' ) )
						 : null;
		let sel3Source = sel3
						 ? Array.from( sel3.querySelectorAll( 'option:not(:first-child)' ) )
						 : null;

		if ( !sel1 || !button ) return;

		function store( what, val ) {
			if ( ['sel1', 'sel2', 'sel3'].includes( what ) ) {
				window.localStorage.setItem( 'menu-based-dropdowns-' + what + '[' + hash + ']', val );
			}
		}

		function getStored( what ) {
			if ( ['sel1', 'sel2', 'sel3'].includes( what ) ) {
				return window.localStorage.getItem( 'menu-based-dropdowns-' + what + '[' + hash + ']' );
			}
			return null;
		}

		function restore() {
			var val1 = getStored( 'sel1' );
			var val2 = getStored( 'sel2' );
			var val3 = getStored( 'sel3' );

			// Assuming sel1, sel2, and sel3 are already defined elsewhere in your code as the respective DOM elements.
			sel1.value = val1
						 ? val1
						 : '0';
			sel1.classList.add( 'is-initialized' );
			sel1.style.color = 'unset';

			if ( val2 === null || val2 === DO_NOT_PRESELECT ) {
				if ( sel2 ) {
					sel2.value = '0';
					sel2.classList.add('is-initialized');
					sel2.style.color = 'unset';
				}
			}

			if ( val3 === null || val3 === DO_NOT_PRESELECT ) {
				if ( sel3 ) {
					sel3.value = '0';
					sel3.classList.add( 'is-initialized' );
					sel3.style.color = 'unset';
				}
			}

			// If you were using the .triggerHandler('change') for event delegation or similar,
			// you'd need to manually create and dispatch the event.
			const customChangeEvent = new CustomEvent( 'change', {
				detail: { isRestoring: true }
			} );
			sel1.dispatchEvent( customChangeEvent );
		}

		function repopulateOptions( name, sel, currParentVal, options ) {
			/**
			 * count the number of proper options (excluding the first option that only shows the prompt)
			 */
			let cntVisible = 0;

			Array.from( sel.children ).forEach( ( child, idx ) => {
				if ( idx !== 0 ) sel.removeChild( child );
			} );

			if ( currParentVal !== '0' ) {
				cntVisible = 0;
				options.forEach( opt => {
					if ( String( opt.dataset.parentId ) === currParentVal ) {
						sel.appendChild( opt );
						opt.hidden = false;
						opt.disabled = false;
						cntVisible ++;
					}
				} );
				if ( cntVisible > 0 ) {
					sel.disabled = false;
					sel.parentElement.classList.add( 'is-interactive' );
				} else {
					sel.value = '0';
					sel.disabled = true;
					sel.parentElement.classList.remove( 'is-interactive' );
				}
			} else {
				sel.value = '0';
				sel.disabled = true;
				sel.parentElement.classList.remove( 'is-interactive' );
			}

			return cntVisible;
		}

		function updateControls( name, sel, updateButton ) {
			const val = getStored( name );
			if ( sel.options.length === 2 ) {
				/**
				 * if there is only one proper option, do select it automatically
				 */
				if ( DO_NOT_PRESELECT !== val ) {
					if ( sel.options.length >= 2 ) {
						sel.options[ 1 ].selected = true; //selecting the first real option
					}
					if ( updateButton ) {
						button.disabled = false;
					}
				}
			} else if ( sel.options.length > 2 ) {
				sel.value = ( ( val === DO_NOT_PRESELECT ) || ( val === null ) )
							? '0'
							: val;
				if ( updateButton ) {
					button.disabled = '0' === sel.value;
				}
			} else {
				/**
				 * this level has no applicable options, so just enable the button if an update is requested
				 */
				if ( updateButton ) {
					button.disabled = false;
				}
			}
			sel.classList.add( 'is-initialized' );
			sel.style.color = 'unset';
		}

		window.addEventListener( 'pageshow', function() {
			if ( !sel1.classList.contains( 'is-initialized' ) ) {
				restore();
			}
		} );

		window.addEventListener( 'unload', function() {
			button.classList.remove( 'is-loading' );
			const el = button.querySelector( 'i' );
			if ( el ) el.classList.remove( 'has-spinner-icon' );
		} );

		window.addEventListener( 'pagehide', function() {
			button.classList.remove( 'is-loading' );
			const el = button.querySelector( 'i' );
			if ( el ) el.classList.remove( 'has-spinner-icon' );
		} );

		sel1.addEventListener( 'change', function( e ) {
			const curr = sel1.value;

			if ( !event?.detail?.isRestoring ) {
				store( 'sel1', sel1.value );
				store( 'sel2', '0' );
				store( 'sel3', '0' );
			}

			if ( !sel2 ) {
				button.disabled = curr === '0';
			} else {
				if ( !sel2Source ) {
					sel2Source = Array.from( sel2.querySelectorAll( 'option:not(:first-child)' ) );
				}
				repopulateOptions( 'sel2', sel2, curr, sel2Source );
				updateControls( 'sel2', sel2, !sel3 );

				sel2.dispatchEvent( new Event( 'change', { 'bubbles': true } ) );
			}
		} );

		if ( sel2 ) {
			sel2.addEventListener( 'change', function( e ) {
				// Disable button if there is nothing selected in the 2nd dropdown
				let val = sel2.value;

				store( 'sel2', val === '0'
							   ? DO_NOT_PRESELECT
							   : val );

				if ( sel3 ) {
					let currOption = Array.from( sel2.querySelectorAll( 'option' ) ).find( opt => opt.value === val );
					let currParentId = currOption
									   ? currOption.getAttribute( 'data-object-id' )
									   : '';

					if ( !sel3Source ) {
						sel3Source = Array.from( sel3.querySelectorAll( 'option:not(:first-child)' ) );
					}

					repopulateOptions( 'sel3', sel3, currParentId, sel3Source );
					updateControls( 'sel3', sel3, false );

					button.disabled = ( sel3.options.length > 1 && sel3.value === '0' ) || ( val === '0' );

				} else {
					button.disabled = val === '0';
				}
			} );
		}

		if ( sel3 ) {
			sel3.addEventListener( 'change', function( e ) {
				if ( !e.isRestoring ) store( 'sel3', sel3.value );
				button.disabled = sel3.value === '0';
			} );
		}

		button.addEventListener( 'click', function( e ) {
			let select;
			if ( sel3 ) {
				if ( sel3.querySelectorAll( 'option' ).length > 1 ) {
					select = sel3;
				}
			} else if ( sel2 ) {
				if ( sel2.querySelectorAll( 'option' ).length > 1 ) {
					select = sel2;
				}
			} else {
				select = sel1;
			}

			let opt = select.querySelector( 'option:checked' );
			let val = opt.value;

			button.classList.add( 'is-loading' );
			let icon = button.querySelector( 'i' );
			if ( icon ) {
				icon.classList.remove( 'has-right-angle-icon' );
				icon.classList.add( 'has-spinner-icon' );
			}

			if ( !isNaN( val ) ) { // Replaces $.isNumeric
				button.closest( 'form' ).submit();
			} else {
				if ( val.startsWith( '//' ) || val.startsWith( 'http://' ) || val.startsWith( 'https://' ) ) {
					window.location.assign( val );
				} else {
					window.location.assign( window.location.origin + val );
				}
				e.preventDefault();
				return false;
			}
			return true;
		} );

		restore();

	} );
} );
